import { Navigate, Route, Routes } from "react-router-dom";

import { SubNav } from "@/app/Shell";
import { PermissionMapPage } from "@/modules/products/PermissionMapPage";
import { ProductVisibilityPage } from "@/modules/products/VisibilityPage";
import { ProductsPage } from "@/modules/products/ProductsPage";
import { ReferenceFilesPage } from "@/modules/products/ReferenceFilesPage";
import { SpacesPage } from "@/modules/products/SpacesPage";
import { ToolUpdatesPage } from "@/modules/products/ToolUpdatesPage";

/** Products — Fabric's 29 `products` routes.
 *
 *  FIVE subpages, house style. Every other module in the console has 3-6
 *  (Registry 6, FOTA 4, Connect 4, Drivers 3), each a concern of its own with
 *  its own filters — so a person finds "tool releases" in the rail rather than
 *  by clicking a row and discovering tabs underneath it.
 *
 *  Two earlier attempts got this wrong in opposite directions: tabs buried
 *  inside a detail page (invisible), then no SubNav at all (which broke the
 *  layout, because `.msubnav` is the sticky strip every module renders under
 *  the app bar). This is the shape the rest of the console already uses.
 */
export function ProductsModule() {
  return (
    <>
      <div style={{ display: "flex", alignItems: "flex-end" }}>
        <SubNav base="/products" tabs={[
          { path: "products", label: "Products" },
          { path: "visibility", label: "Product Visibility" },
          { path: "spaces", label: "Spaces" },
          { path: "reference", label: "Reference files" },
          { path: "tools", label: "Tool updates" },
          { path: "permissions", label: "Permission map" },
        ]} />
      </div>
      <Routes>
        {/* Distinct keys: sibling routes of the same component type at one tree
            position reconcile instead of remounting (D-84). */}
        <Route path="products" element={<ProductsPage key="products" />} />
        {/* ENTITLEMENT, the twin of Asset Catalog / Model Visibility. They
            answer different halves — may this company use the product at all,
            versus which MODELS within it they may build with — and are edited
            in the same shape so knowing one teaches the other. */}
        <Route path="visibility" element={<ProductVisibilityPage key="visibility" />} />
        <Route path="spaces" element={<SpacesPage key="spaces" />} />
        <Route path="reference" element={<ReferenceFilesPage key="reference" />} />
        <Route path="tools" element={<ToolUpdatesPage key="tools" />} />
        <Route path="permissions" element={<PermissionMapPage key="permissions" />} />
        <Route path="*" element={<Navigate to="products" replace />} />
      </Routes>
    </>
  );
}
